import React from 'react';
import Button from '../../../component/ui/Button';
import './index.scss';

function Header({ headerTitle, buttons, dropDownButtons, closeButton }) {
	return (
		<div
			style={{
				position: 'sticky',
				top: 0,
				zIndex: 100,
			}}
		>
			<div className="product-pg-header add-product">
				<p>{headerTitle}</p>
				<div className="add-product-button">
					{buttons?.map((button, index) =>
						!button?.isDropdown ? (
							<Button
								key={button?.id || index}
								type="button"
								button={button?.button}
								className={`${button?.className} mt-0 px-4 px-md-3`}
								onClick={button?.handler}
								loader={button?.loader}
								disabled={button?.disabled || false}
							/>
						) : (
							<div
								className="dropdown"
								key={button.id}
							>
								<button
									className="btn btn-gray mt-0 px-4 px-md-2 w-100 dropdown-toggle"
									style={{
										height: '32px',
										fontSize: '14px',
										fontWeight: '500',
										background: '#daddec',
									}}
									type="button"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									{button.title}
								</button>
								<ul className="dropdown-menu font-14">
									{button.options.map((option, index) => {
										return (
											<li>
												<button
													style={{
														cursor: option.disabled ? 'not-allowed' : 'pointer',
													}}
													disabled={option.disabled || false}
													className={`dropdown-item dropdown-item-hover w-100 border-0 py-2 ${button.options.length === index + 1 ? '' : 'border-bottom'}`}
													onClick={option.handler}
												>
													{option.title}
												</button>
											</li>
										);
									})}
								</ul>
							</div>
						),
					)}

					{dropDownButtons?.map((dropdown, index) => (
						<div
							key={`dropdown-${index}`}
							className="dropdown-section"
							style={{
								position: 'relative',
							}}
						>
							<Button
								type="button"
								className="btn btn-gray mt-0 px-4 dropdown-toggle"
								button="Update PO Status"
								onClick={() => dropdown.setShow(!dropdown.show)}
							/>
							{dropdown.show && (
								<div
									className="dropdown-menu show font-14"
									style={{
										width: '160px',
										position: 'absolute',
										zIndex: 1000,
										maxHeight: '300px',
										overflowY: 'auto',
										marginTop: '10px',
									}}
								>
									{dropdown.items?.map((item, itemIndex) => (
										<a
											key={`dropdown-item-${itemIndex}`}
											className="dropdown-item"
											onClick={() => item.handler()}
											style={{ cursor: 'pointer' }}
										>
											{item.title}
										</a>
									))}
								</div>
							)}
						</div>
					))}
					{closeButton?.showCloseButton && (
						<Button
							type="button"
							close
							button=""
							className="mt-0 btn-danger add-pro"
							onClick={closeButton?.handler}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default Header;
